import { Skeleton } from '@mantine/core';
import { Column, Wrapper } from './UserButtonLoader.style';

export type UserButtonLoaderProps = {};

export function UserButtonLoader(_props: UserButtonLoaderProps) {
  return (
    <Wrapper className='UserButtonLoader-wrapper' data-testid='UserButtonLoader-wrapper'>
      <Skeleton circle radius={30} width={30} height={30} animate />
      <Column>
        <Skeleton width={80} height={12} animate />
        <Skeleton width={100} height={10} animate />
      </Column>
    </Wrapper>
  );
}

export default UserButtonLoader;
